import { CSWSupportedTheme } from '@lmn/common-search-widget';
import type { ThemeName } from '@lmn/design-system';

const THEME_MAP: Record<ThemeName, CSWSupportedTheme | undefined> = {
  'abe-sapien': undefined,
  aquaman: undefined,
  bluejay: undefined,
  'blue-whale': undefined,
  'captain-america': CSWSupportedTheme.CaptainAmerica,
  cinderella: undefined,
  doraemon: undefined,
  dragonfly: undefined,
  garfield: CSWSupportedTheme.Garfield,
  goldfinger: undefined,
  'holiday-guru': CSWSupportedTheme.Iceberg, // Deprecated, kept for backward compatibility
  iceberg: CSWSupportedTheme.Iceberg,
  milhouse: undefined,
  mystique: CSWSupportedTheme.Mystique,
  mymiglia: CSWSupportedTheme.MyMiglia,
  nemo: undefined,
  'pink-panther': CSWSupportedTheme.PinkPanther,
  skeletor: CSWSupportedTheme.Skeletor,
  'vault-boy': CSWSupportedTheme.VaultBoy,
  vibra: CSWSupportedTheme.Vibra,
  midnight: undefined,
  pomegranate: undefined,
  poppy: undefined,
  wolverine: undefined,
};

const getTheme = (themeName: ThemeName): CSWSupportedTheme => THEME_MAP[themeName] || CSWSupportedTheme.PinkPanther;

export default getTheme;
